import React from 'react';
import './assets/styles/shared.scss';
import './App.css';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {Router} from './Router';
import { IntlProvider } from 'react-intl';
import { messages } from './assets/translations/messages';
import { Toaster } from 'react-hot-toast';
import Cookies from "js-cookie";
import { MenuBar } from './components';
import { LoginProvider } from './context/LoginContext';
import { RequestProvider } from './context/RequestContext';
import { useLoginContext } from './hooks/useLoginContext';
import { red } from '@mui/material/colors';
import { SignProvider } from './context/SignContext';

declare module '@mui/material/styles' {
    interface Palette {
        neutral: Palette['primary'];
    }

    // allow configuration using `createTheme`
    interface PaletteOptions {
        neutral?: PaletteOptions['primary'];
    }
}

// Update the Button's color prop options
declare module '@mui/material/Fab' {
    interface FabPropsColorOverrides {
        neutral: true;
    }
}

function App() {
    const theme = createTheme({
        palette: {
            neutral: {
                main: '#8491a3',
                contrastText: '#fff',
            },
            primary: {
                main: "#076a61",
              },
        },
    });


    const language = Cookies.get('language') || 'es';

    return (
        <div className="App">
            <LoginProvider>
                <RequestProvider>
                    <SignProvider>
                        <IntlProvider locale={language} messages={messages[language] as any}>
                            <ThemeProvider theme={theme}>
                                <Router/>
                                <Toaster
                                    position="top-center"
                                    gutter={12}
                                    toastOptions={{
                                        duration: 5000,
                                        style: {
                                            minWidth: '320px',
                                            maxWidth: '520px',
                                            padding: '14px 18px',
                                            borderRadius: '8px',
                                            border: '1px solid rgba(7, 106, 97, 0.12)',
                                            background: '#ffffff',
                                            color: '#20302d',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            lineHeight: 1.35,
                                            boxShadow: '0 18px 42px rgba(22, 42, 39, 0.22)',
                                        },
                                        success: {
                                            style: {
                                                borderColor: 'rgba(79, 174, 50, 0.35)',
                                                background: '#f3fbf0',
                                                color: '#1f6f19',
                                            },
                                            iconTheme: {
                                                primary: '#4fae32',
                                                secondary: '#ffffff',
                                            },
                                        },
                                        error: {
                                            style: {
                                                borderColor: 'rgba(232, 75, 75, 0.38)',
                                                background: '#fff4f2',
                                                color: '#9b241f',
                                            },
                                            iconTheme: {
                                                primary: '#e84b4b',
                                                secondary: '#ffffff',
                                            },
                                        },
                                        loading: {
                                            style: {
                                                borderColor: 'rgba(255, 174, 43, 0.42)',
                                                background: '#fff8ea',
                                                color: '#8a5c09',
                                            },
                                        },
                                    }}
                                />
                            </ThemeProvider>
                        </IntlProvider> 
                    </SignProvider>
                </RequestProvider>
            </LoginProvider>
        </div>
    );
}

export default App;
